import { render, staticRenderFns } from "./external-2021-data-upload.vue?vue&type=template&id=5da76302&scoped=true"
import script from "./external-2021-data-upload.vue?vue&type=script&lang=js"
export * from "./external-2021-data-upload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da76302",
  null
  
)

export default component.exports